import { createSlice } from "@reduxjs/toolkit";
import { RootGlobalState } from "../stores/global";

export interface ProlificUser {
  prolificId: string;
  _id?: string;
  experiments: string[];
  metadata: { [key: string]: string };
}

export interface ProlificExperiments {
  user?: ProlificUser;
  runProlific: boolean;
  experiment: string;
}

const initialState: ProlificExperiments = {
  runProlific: false,
  experiment: "",
};

export const GlobalSlice = createSlice({
  name: "ProlificExperiments",
  initialState,
  reducers: {
    setUser(state: ProlificExperiments, action: { payload: ProlificUser }) {
      state.user = action.payload;
    },
    setRunProlific(state: ProlificExperiments, action: { payload: boolean }) {
      state.runProlific = action.payload;
    },
    setExperiment(state: ProlificExperiments, action: { payload: string }) {
      state.experiment = action.payload;
    },
  },
});
export const { setUser, setRunProlific, setExperiment } = GlobalSlice.actions;

export const selectUserId = (state: RootGlobalState) => state.global.user?._id;
export const selectProlificExp = (state: RootGlobalState) =>
  state.global.experiment;
export const selectRunProlific = (state: RootGlobalState) =>
  state.global.runProlific;

export const selectProlificId = (state: RootGlobalState) =>
  state.global.user?.prolificId;
export const selectProlificUser = (state: RootGlobalState) => state.global.user;
export default GlobalSlice.reducer;
